<template>
  <router-view />
</template>
<script>
import { routes } from '@/config'
export default {
  name: 'certifition-redirect',
  data() {
    return {};
  },
  created() {
    const redirectPath = this.$route.path === routes.certificationRedirect ? routes.chooseService : routes.certificationExtend;
    // console.warn(`the path：'%c${this.$route.path}' is deprecated，please use：%c${redirectPath} instead of it`, 'background:#008000;color:#fff', 'background:#008000;color:#fff');
    console.warn(`路径："${this.$route.path}"已经过时，请使用"${redirectPath}"替换它!`);

    this.$router.replace({
      path: redirectPath,
      params: this.$route.params,
      query: this.$route.query,
    });
  },
}
</script>